import { Point } from '@/models/point';
import { Config } from '@/utils/Config';
import { Consoler } from '@/utils/Consoler';
import { EventBus } from '@/utils/EventBus';
import { angularAlexMapDirectiveTemplate } from './angular-alex-map.directive.template';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function angularAlexMapDirective(localizations) {
  const directive = {
    restrict: 'E',
    template: angularAlexMapDirectiveTemplate,

    scope: {},

    link: (scope, element) => {
      scope.localizations = localizations;

      element.on('App-Destroy', () => {
        scope.$destroy();
      });

      scope.$root.$on('al-map:created', (event, alMap) => {
        scope.$root.alMap = alMap;
      });

      scope.pointStyle = {
        icon: {
          anchor: [0.5, 1],
          opacity: 1,
          scale: 0.5,
          src:
            Config.Settings.ApiBaseUrl +
            Config.GisServicesServicesUrl +
            '/assets/icons/karta_pin.png'
        },
        text: {
          offsetY: 20
        }
      };

      scope.map = {
        isFullScreen: false,
        sidebarLeft: false,
        sidebarLeftTransparent: false,
        sidebarRight: false,

        pos: {
          coordinates: [Config.DefaultMapCoordsLng, Config.DefaultMapCoordsLat],
          projection: 'EPSG:3006',
          zoom: Config.DefaultMapZoom
        },

        basePresets: [
          {
            presetName: Config.GisServicesMapLayer,
            displayName: localizations.mapLayers.extweb_karta
          }
        ],

        addonPresets: [
          {
            presetName: 'extweb/sbo',
            displayName: localizations.mapLayers.extweb_sbo,
            visible: true
          },
          {
            presetName: 'extweb/dsbo',
            displayName: localizations.mapLayers.extweb_dsbo,
            visible: false
          }
        ],

        activePresets: [Config.GisServicesMapLayer],

        vectorLayers: []
      };

      scope.fullscreen = (isFullScreen: boolean) => {
        scope.map.isFullScreen = isFullScreen;
        EventBus.$emit(Config.MapSetFullScreenEvent, isFullScreen);
        setTimeout(() => {
          scope.$root.alMap.updateSize();
        });
      };

      scope.sidebarRight = (show: boolean) => {
        EventBus.$emit(Config.MapSetShowSidebarRightEvent, show);
      };

      scope.$root.$on('al-feature:selected', (event, alFeature, model) => {
        scope.$apply(() => {
          setTimeout(() => {
            Consoler.debugLog('Map feature selected', model);
            EventBus.$emit(Config.MapPointSelectedEvent, model);
          });
        });
      });
      scope.$root.$on('al-feature:deselected', () => {
        scope.$apply(() => {
          Consoler.debugLog('Map feature deselected');
          EventBus.$emit(Config.MapPointSelectedEvent, null);
        });
      });

      EventBus.$on(Config.MapSetPointsEvent, (points: Point[]) => {
        scope.$apply(() => {
          Consoler.debugLog('Setting points of interest to map', points);
          scope.points = points;
        });
      });

      EventBus.$on(Config.MapClearSelectedPointsEvent, () => {
        scope.$apply(() => {
          setTimeout(() => {
            scope.$root.alMap.clearSelections();
          });
        });
      });
    }
  };
  return directive;
}
